export class SizingErrorUtil {
  /**
   * Utility function used to normalize backend validation errors
   * @param errors
   * @returns Formats objects with {key, message}.
   */
  static groupTemplateErrors(errors: any) {
    if (!Array.isArray(errors)) return [];
    return errors.map((err) => {
      const segments = (err?.instancePath || '').split('/').filter(Boolean);
      let recordIndex: number | null = null;
      if (segments.length && !isNaN(Number(segments[0]))) {
        recordIndex = Number(segments[0]); // capture record id
        segments.shift();
      }
      let parentKey = '';
      let key = '';
      let field = '';
      const lastPropertiesIndex = segments.lastIndexOf('properties');
      if (err.keyword === 'additionalProperties') {
        key = err.params?.additionalProperty ?? '';
        if (lastPropertiesIndex !== -1 && segments[lastPropertiesIndex - 1]) {
          parentKey = segments[lastPropertiesIndex - 1];
        }
        if (lastPropertiesIndex !== -1 && segments[lastPropertiesIndex + 1]) {
          field = segments[lastPropertiesIndex + 1];
        }
      } else if (err.keyword === 'required' && err.params?.missingProperty) {
        key = err.params.missingProperty;
        if (lastPropertiesIndex !== -1 && segments[lastPropertiesIndex - 1]) {
          parentKey = segments[lastPropertiesIndex - 1];
        } else if (segments.includes('template')) {
          parentKey = 'template';
        }
        if (lastPropertiesIndex !== -1 && segments[lastPropertiesIndex + 1]) {
          field = segments[lastPropertiesIndex + 1];
        } else if (segments.includes('template')) {
          field = 'template';
        }
      } else {
        key = segments[segments.length - 1] ?? '';
        if (lastPropertiesIndex !== -1 && segments[lastPropertiesIndex + 1]) {
          field = segments[lastPropertiesIndex + 1];
        } else if (segments.includes('template')) {
          field = 'template';
        }

        if (lastPropertiesIndex !== -1 && segments[lastPropertiesIndex - 1]) {
          parentKey = segments[lastPropertiesIndex - 1];
        } else {
          parentKey = segments[segments.length - 2] ?? '';
        }
      }

      return {
        recordIndex,
        parentKey,
        key,
        field,
        message: err?.message ?? '',
      };
    });
  }
  /**
   * Group errors by parentKey for easier template rendering
   */
  static groupErrorsByParent(errors: any) {
    const map = new Map();
    for (const err of errors) {
      const recordIndex = err.recordIndex ?? -1;
      const parentKey = err.parentKey ?? "";
      if (!map.has(recordIndex)) {
        map.set(recordIndex, new Map());
      }
      const parentMap = map.get(recordIndex);
      if (!parentMap.has(parentKey)) {
        parentMap.set(parentKey, []);
      }
      parentMap.get(parentKey).push(err);
    }
    // convert to array structure
    return Array.from(map.entries()).map(([recordIndex, parentMap]) => ({
      recordIndex,
      parents: Array.from(parentMap.entries()).map(([parentKey, errors]) => ({
        parentKey,
        errors,
      })),
    }));
  }
}
